import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import TimeTrackingOverviewByMonth = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingOverview.TimeTrackingOverviewByMonth;

@Injectable({providedIn: 'root'})
export class TimeTrackingOverviewService extends BaseEndpointService<TimeTrackingOverviewByMonth> {
  protected override endpoint = '/time-tracking/overview/month';
  protected override multiSelectTextFields = ['id'] as const;
}
